import { IthHelmet } from "@/components";
import { useSse } from "@/hooks";
import Schedule from "./Schedule";
import PpmNotification from "./PpmNotification";
import Sigma from "./sigma";


const Home: React.FC = () => {
  useSse();

  return (
    <div className="flex">
      <IthHelmet pageTitle="今天" report />
      <div className="flex-none w-90 xl:w-100">
        <Schedule />
      </div>
      <div className="flex-1 ml-8">
        <PpmNotification />
      </div>
      <Sigma />
    </div>
  );
};

export default Home;
